<div fxLayout="column" fxFlexFill>
  <app-header class="header-div"></app-header>
  <router-outlet (activate)="onActivate()"></router-outlet>
  <app-footer class="footer bottom-0"></app-footer>
  <app-button-to-top [container]="this.container"></app-button-to-top>
</div>
<app-one-tap></app-one-tap>
